import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import { navigation } from '../nav-config';
import { hasTouchEvents } from '../util';
import NavArticles from './nav-articles';

class Component extends BaseComponent {
    render() {
        return (
            <nav-bar>
                {navigation.map(item => this.renderSection(item))}
            </nav-bar>
        );
    }

    renderSection = (item) => {
        return (
            <section class='header-section'>
                <a
                  class='header'
                  href={hasTouchEvents && item.submenu ? `#nav-bar${item.link}` : item.link}
                  target={!item.submenu && item.target ? item.target : ''}
                  onClick={() => this.trackClick(item.name)}
                >
                    <h1>{item.name}</h1>
                </a>
                {this.renderSubmenus(item)}
            </section>
        );
    }

    renderSubmenus = (item) => {
        if (item.submenu) {
            return (
                <div class='submenu'>
                    {item.submenu.map(subitem => this.renderSubmenu(item, subitem))}
                    {this.renderNavArticles(item)}
                </div>
            );
        }

        return null;
    }

    renderSubmenu = (item, subitem) => {
        const label = `${item.name} - ${subitem.name}`;

        return (
            <div class='submenu-category'>
                <a href={subitem.link} onClick={() => this.trackClick(label)}>
                    <h2>{subitem.name}</h2>
                    <ul>
                        {subitem.links.map(link => this.renderSubmenuList(item, subitem, link))}
                    </ul>
                </a>
            </div>
        );
    }

    renderSubmenuList = (item, subitem, destination) => {
        const lo_label = `${item.name} - ${destination.name}`;

        if (destination.logged_in && this.props.logged_in) {
            const li_label = `${item.name} - ${destination.logged_in.name}`;

            return (
                <li>
                    <a
                      href={destination.logged_in.link}
                      class='nav-link'
                      onClick={() => this.trackClick(li_label)}
                    >
                        {destination.logged_in.name}
                    </a>
                </li>
            );
        }

        return (
            <li>
                <a
                  href={destination.link}
                  class='nav-link'
                  onClick={() => this.trackClick(lo_label)}
                >
                    {destination.name}
                </a>
            </li>
        );
    }

    renderNavArticles = (item) => {
        if (item.articles) {
            return (
                <NavArticles
                  category={item.name}
                  header={item.articles.name}
                  tag={item.articles.tag}
                  url={item.articles.url}
                />
            );
        }

        return null;
    }

    trackClick = (label) => {
        const category = 'Navigation';
        const action = this.props.logged_in ? 'LI Click' : 'LO Click';

        this.props.trackEvent([category, action, label]);
        this.props.trackPromo([category, label]);

        return true;
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: payload => dispatch({ type: 'ga:event', payload: payload }),
    trackPromo: payload => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/nav-bar.js